import {Fragment, useEffect, useState} from 'react';
import "./chargerDevices/chargerDevices.css";
import axios from 'axios'; //fetches data from api
import ChargerDevices from './chargerDevices/ChargerDevices';
//import DeviceData from './deviceMasterList.json' 
//local data for testing 

export default function ChargerDevicesList() {
  const [index, updateIndex] = useState({}); // index for searching items
  const [deviceListData, updateData] = useState({}); // data from api
  const [ready, updateReady] = useState(false); // wait for data then display plugin
  
  async function getIndexes(){
    let data = {}
    let dataURL = '';
    await axios.get(`${window.origin}/wp-json/wp/v2/posts/4830`)
      .then(res =>{
        dataURL = res.data.content.rendered
        dataURL = dataURL.substring(3, dataURL.indexOf('<', 3))
      })
    await axios.get(dataURL)
      .then(res => {
        dataURL = res.data.guid.rendered
      })
    await axios.get(dataURL) // api call
        .then(res => {
          data = res.data
          updateData(res.data) // update data variable
        })
    Object.keys(data).forEach(category => { // update index for each of these items
      if(category === 'Streaming' || category === 'Home Automation' || category === 'Smart TVs' || category === 'Gaming'){
        data[category].forEach(item => {
          updateIndex(index => ({...index, [item["Brand"] + ' ' + item["Device Model/Series"]]:[item, category]}));
        })
      }
    })
    updateReady(true); // when done, update plugin
  };

  useEffect(() => { // when first loading page, runs this, ready will be false, then will update again when ready changes
    if(ready === false ){
      getIndexes();
    }
  }, [ready])

  return (
    <Fragment>
      {ready === true && <ChargerDevices jsonData={deviceListData} index={index}/> /* if ready is true, load plugin with data attached */ }
    </Fragment>
  );
}








